import './Carousel.scss';
import { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { mapAbilityIcon } from '../../utils/iconUtils';
import { Text } from '../';

export default function BeaconReadingsCarousel({ readings, visibleCount }) {
  const containerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollButtons = () => {
    const container = containerRef.current;
    if (!container) return;

    const { scrollLeft, scrollWidth, clientWidth } = container;
    const tolerance = 2;

    setCanScrollLeft(scrollLeft > tolerance);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - tolerance);
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    updateScrollButtons();
    const onScroll = () => {
      window.requestAnimationFrame(updateScrollButtons);
    };

    container.addEventListener('scroll', onScroll);
    return () => container.removeEventListener('scroll', onScroll);
  }, []);

  const scrollByCards = (direction) => {
    const container = containerRef.current;
    if (!container) return;

    const card = container.querySelector('.carousel-card');
    if (!card) return;

    const gap = parseFloat(getComputedStyle(container.querySelector('.carousel-track')).gap || '0');
    const cardWidth = card.offsetWidth + gap;

    container.scrollBy({
      left: direction * cardWidth,
      behavior: 'smooth',
    });
  };

  return (
    <div className="carousel-wrapper mb-3">
      {canScrollLeft && (
        <Button
          className="carousel-button carousel-button-prev"
          variant="secondary"
          onClick={() => scrollByCards(-1)}
        >
          <i className="sonarIcon sonarIcon-left-arrow fs-sm" />
        </Button>
      )}

      <div className="carousel-container" ref={containerRef}>
        <div
          className="carousel-track"
          style={
            {
              '--visible-count': visibleCount.toString(),
              '--gap': '0.5rem',
            } as React.CSSProperties
          }
        >
          {readings.map((reading, idx) => (
            <div className="carousel-card" key={idx}>
              <div className="d-flex flex-column align-items-center justify-content-around w-100 h-100">
                {mapAbilityIcon(reading.ability)}
                <Text className="title-text user-select-none fw-normal fs-md p-0">
                  {parseFloat(reading.value).toFixed(2)}
                </Text>
                <Text
                  className="ability-name d-inline-block text-truncate user-select-none fw-light fs-sm p-0"
                  title={reading.ability}
                >
                  {reading.ability}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>

      {canScrollRight && (
        <Button
          className="carousel-button carousel-button-next"
          variant="secondary"
          onClick={() => scrollByCards(1)}
        >
          <i className="sonarIcon sonarIcon-right-arrow fs-sm" />
        </Button>
      )}
    </div>
  );
}
